import {
  AdditionalConfiguration,
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionConfigurationControlType,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { CrossBorderBrokerActivityModel } from './cross-border-broker-activity.model';

export class CrossBorderBrokerConfiguration extends ReportSectionConfigurationBase {
  typeName = 'CrossBorderBrokerConfiguration';
  nodataLocalizationKeyName = 'bnyCrossBorderBrokerActivity';
  readonly reportSection = ReportSection.CrossBorderBrokerActivity;
  readonly applicableReportTypes = [ReportType.BnyManagementReport];
  readonly reportViewModelSections = [ReportViewModelSection.BnyManagementReport_CrossBorderBrokerActivity];
  displayName = 'Cross-Border Broker Activity';
  name = 'crossBorderBrokerActivityTitle';
  maxSize = 4;
  defaultSize = 2;
  minSize = 2;

  readonly availableDataSections = [
    {
      name: 'brokerName',
      displayName: 'Broker',
      isSelected: true,
      canConfigure: false,
      isStatic: true,
      property: 'brokerName',
      type: ReportSectionConfigurationControlType.Text
    },
    {
      name: 'drsIssued',
      displayName: 'DRs Issued',
      isSelected: true,
      canConfigure: true,
      property: 'drsIssued',
      type: ReportSectionConfigurationControlType.Number
    },
    {
      name: 'drsIssuedTrans',
      displayName: '# Trans (Issued)',
      isSelected: true,
      canConfigure: true,
      property: 'drsIssuedTrans',
      type: ReportSectionConfigurationControlType.Number
    },
    {
      name: 'drsCancelled',
      displayName: 'DRs Canceled',
      isSelected: true,
      canConfigure: true,
      property: 'drsCancelled',
      type: ReportSectionConfigurationControlType.Number
    },
    {
      name: 'drsCancelledTrans',
      displayName: '# Trans (Cancelled)',
      isSelected: true,
      canConfigure: true,
      property: 'drsCancelledTrans',
      type: ReportSectionConfigurationControlType.Number
    },
    {
      name: 'netIssueCancel',
      displayName: 'Net Issue/Cancel',
      isSelected: true,
      canConfigure: true,
      property: 'netIssueCancel',
      type: ReportSectionConfigurationControlType.Number
    }
  ];

  override readonly configurationControls = [
    {
      name: 'crossBrokerBorderShowTotals',
      displayName: 'Show Totals for all data points',
      type: 'totalRowControl'
    }
  ];

  override additionalConfiguration: AdditionalConfiguration = {
    isTotalRowShown: true
  };
}

export interface CrossBorderBrokerActivityData {
  [ReportViewModelSection.BnyManagementReport_CrossBorderBrokerActivity]: CrossBorderBrokerActivityModel;
}
